<template>
  <div class="col-md-1 left-bar">
    <div class="row">
      <!-- <router-link to="/login"> -->
        <div class="left-link logo-link text-center">
          <img src=".././assets/images/Symbol.svg" alt="">
        </div>
      <!-- </router-link> -->
    </div>
    <div class="row" @click="toggleSideBarMobile()">
      <router-link to="/video/dashboard/cams">
        <div class="left-link text-center">
          <img src=".././assets/images/video_yellow.svg" alt="" v-if="checkRoute('/video/dashboard/cams')">
          <img src=".././assets/images/video_white.svg" alt="" v-else>
          <p>Dashboard</p>
        </div>
      </router-link>
    </div>
    <div class="row" @click="toggleSideBarMobile()">
      <router-link to="/events">
        <div class="left-link text-center">
          <img src=".././assets/images/alerts_yellow.svg" alt="" v-if="checkRoute('/events')">
          <img src=".././assets/images/alerts.svg" alt="" v-else>
          <p>Events</p>
        </div>
      </router-link>
    </div>
    <div class="row" @click="toggleSideBarMobile()">
      <router-link to="/attendance/tracking">
        <div class="left-link text-center">
          <img src=".././assets/images/archive_yellow.svg" alt="" v-if="checkRoute('/attendance/tracking')">
          <img src=".././assets/images/archive.svg" alt="" v-else>
          <p>Attendance</p>
        </div>
      </router-link>
    </div>
      <div class="row" @click="toggleSideBarMobile()">
      <!-- student management -->
      <router-link to="/student-management">
        <div class="left-link text-center">
          <img src=".././assets/images/persons_yellow.svg" alt="" v-if="checkRoute('/student-management')">
          <img src=".././assets/images/persons.svg" alt="" v-else>
          <p>Identity Mgmt.</p>
        </div>
      </router-link>
    </div>
    <div class="row" @click="toggleSideBarMobile()">
      <!-- users management -->
      <router-link to="/user-management">
        <div class="left-link text-center">
          <img src=".././assets/images/user_mng_yellow.svg" alt="" v-if="checkRoute('/user-management')">
          <img src=".././assets/images/user_mng.svg" alt="" v-else>
          <p>User Mgmt.</p>
        </div>
      </router-link>
    </div>
    <div class="row" @click="toggleSideBarMobile()">
      <router-link to="/access-logs">
        <div class="left-link text-center">
          <img src=".././assets/images/actions_yellow.svg" alt="" v-if="checkRoute('/access-logs')">
          <img src=".././assets/images/actions_white.svg" alt="" v-else>
          <p>User actions</p>
        </div>
      </router-link>
    </div>
    <div class="row" @click="toggleSideBarMobile()">
      <router-link to="/camera/settings">
        <div class="left-link text-center">
          <img src=".././assets/images/camera_yellow.svg" alt="" v-if="checkRoute('/camera/settings')">
          <img src=".././assets/images/camera_white.svg" alt="" v-else>
          <p>Camera settings</p>
        </div>
      </router-link>
    </div>
    <div class="row" @click="toggleSideBarMobile()">
      <router-link :to="{name: 'my-profile'}">
        <div class="left-link text-center" >
          <img src=".././assets/images/profile_yellow.svg" alt="" v-if="checkRoute('/my-profile')">
          <img src=".././assets/images/profile.svg" alt="" v-else>
          <p>My account</p>
        </div>
      </router-link>
    </div>
    <div class="row" @click="toggleSideBarMobile()">
      <!-- <router-link :to="{name: 'my-profile'}"> -->
        <div class="left-link text-center" >
          <img src=".././assets/images/settings_yellow.svg" alt="" v-if="false">
          <img src=".././assets/images/settings.svg" alt="">
          <p>System settings</p>
        </div>
      <!-- </router-link> -->
    </div>
    <div class="row" @click="toggleSideBarMobile()">
      <router-link to="/tutorial">
        <div class="left-link text-center">
          <img src=".././assets/images/help_yellow.svg" alt="" v-if="checkRoute('/tutorial')">
          <img src=".././assets/images/help.svg" alt="" v-else>
          <p>Help</p>
        </div>
      </router-link>
    </div>
    <div class="row">
      <a href="#" @click="logout">
        <div class="left-link text-center">Sign out</div>
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Sidebar',
    computed: {
      user_id() {
        return this.$store.state.auth.user_id;
      },
    },
    methods: {
      logout() {
        this.$store.dispatch('auth/logout').then(() => this.$router.push('/login'));
      },
      checkRoute(route) {
        return this.$route.path == route;
      },
      toggleSideBarMobile() {
        if(this.$store.state.mobile)
          this.$store.commit("toggleSidebar");
      }
    },
  };
</script>

<style lang="scss">
  @import ".././assets/scss/app.scss";
</style>

